export const CLOUD = 'cloud';
